'use strict';

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Image, Platform, TouchableWithoutFeedback, Animated, View } from 'react-native';
import YPDImage from '@mi/duplo-image-rn';
import yimg from '@mi/youpin-img-change';
import CommonBridge from 'common/CommonBridge';

const defaultImg = CommonBridge.isMishop()
  ? {
      uri:
        'data:image/png;base64,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',
    }
  : {
      uri:
        'data:image/png;base64,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',
    };

class ImageHandler extends PureComponent {
  static wrappedSource = (source, autoResize) => {
    let wrappedSource = { uri: '' };
    if (typeof source === 'function') {
      source = source();
    }
    if (source && source.uri) {
      wrappedSource = JSON.parse(JSON.stringify(source));
      if (wrappedSource.uri.startsWith('//')) {
        wrappedSource.uri =
          Platform.OS === 'web' ? location.protocol + wrappedSource.uri : 'https:' + wrappedSource.uri;
      }
      if (autoResize) {
        // @ts-ignore
        wrappedSource.uri = yimg.resize(wrappedSource.uri);
      }
    }
    return wrappedSource;
  };

  static isObjectValueEqual(obja, objb) {
    const aProps = Object.getOwnPropertyNames(obja);
    const bProps = Object.getOwnPropertyNames(objb);
    if (aProps.length !== bProps.length) {
      return false;
    }
    for (let i = 0; i < aProps.length; i++) {
      const propName = aProps[i];
      if (obja[propName] !== objb[propName]) {
        return false;
      }
    }
    return true;
  }

  static getDerivedStateFromProps(nextProps, prevState = {}) {
    let source = nextProps.source;
    if (typeof source === 'function') {
      source = source();
    }
    if (!ImageHandler.isObjectValueEqual(source, prevState.source)) {
      return {
        source: ImageHandler.wrappedSource(source, nextProps.autoResize),
      };
    }
    return null;
  }

  static propTypes = {
    source: PropTypes.object,
    style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    useDuplo: PropTypes.bool,
    resizeMode: PropTypes.string,
    placeholderResizeMode: PropTypes.string,
    blurRadius: PropTypes.number,
    Placeholder: PropTypes.bool,
    lazyload: PropTypes.bool,
    onPress: PropTypes.func,
    onLoadEnd: PropTypes.func,
    autoResize: PropTypes.bool,
    animate: PropTypes.bool,
    useMemoryCache: PropTypes.bool,
    defaultPlaceholder: PropTypes.string,
    accessibilityLabel: PropTypes.any,
  };

  static defaultProps = {
    source: defaultImg,
    resizeMode: 'contain',
    useDuplo: true,
    blurRadius: 0, // IOS上会有问题  数值太大会模糊掉图片不展示  依旧占位
    lazyload: false,
    Placeholder: true,
    autoResize: true,
    placeholderResizeMode: 'contain',
    animate: false,
    /**
     * 是否开启Duplo RAM缓存，仅当useDuplo为true时生效。默认开启（可能影响App内存）
     * 设置为false时，GC执行期间会清理掉图片占用的内存空间。
     */
    useMemoryCache: true,
  };

  constructor(props) {
    super(props);
    const { source, useDuplo, resizeMode, autoResize } = props;
    const wrappedSource = ImageHandler.wrappedSource(source, autoResize);
    if (useDuplo && !CommonBridge.isWeb()) {
      this.state = {
        source: wrappedSource,
        _resizeMode: resizeMode,
        _useDuplo: useDuplo,
        opacity: new Animated.Value(0),
      };
    } else {
      this.state = {
        source: Platform.OS === 'android' ? defaultImg : wrappedSource,
        _resizeMode: Platform.OS === 'android' ? 'center' : resizeMode,
        _useDuplo: false,
        opacity: new Animated.Value(0),
      };
    }
  }

  componentWillUnmount() {
    // 使用多普勒图，在组件即将卸载时标记其内存被释放
    if (this.state._useDuplo && !this.props.useMemoryCache) {
      try {
        YPDImage.recycle(this.state.source.uri);
      } catch (e) {
        console.warn('YPDImage recycle error: ', e);
      }
    }
  }

  onLoadEnd = (...args) => {
    const { onLoadEnd, animate } = this.props;

    if (!animate) {
      onLoadEnd && onLoadEnd(args);
      return;
    }

    // if (!this.state._useDuplo && animate) {
    Animated.timing(this.state.opacity, {
      toValue: 1,
      duration: 600,
      useNativeDriver: true,
    }).start();
    // }

    onLoadEnd && onLoadEnd(...args);
  };

  // onLoadEvent = (event) => {
  //     // web上没有nativeEvent
  //   const name = event.nativeEvent ? event.nativeEvent.name : event.name;
  //   if (name === 'onLoadFinish') {
  //     const { onLoadEnd, animate } = this.props;
  //     if (!animate) {
  //         onLoadEnd && onLoadEnd();
  //         return;
  //     }
  //     Animated.timing(this.state.opacity, {
  //         toValue: 1,
  //         duration: 600,
  //         useNativeDriver: true,
  //     }).start();
  //   }
  // };

  render() {
    const {
      onPress,
      lazyload,
      style,
      blurRadius,
      Placeholder,
      placeholderResizeMode,
      animate,
      defaultPlaceholder,
      ...rest
    } = this.props;
    const { accessibilityLabel } = this.props;
    let imageContent = null;
    if (this.state._useDuplo) {
      const img = defaultPlaceholder || defaultImg;
      imageContent = (
        <YPDImage
          {...rest}
          style={style}
          source={{
            cache: 'force-cache',
            ...this.state.source,
          }}
          blurRadius={blurRadius}
          lazyload={lazyload}
          placeholder={Placeholder ? img : null}
          resizeMode={this.state._resizeMode}
          onLoadEnd={this.onLoadEnd}
          CDNOptmize={true}
          placeholderResizeMode={placeholderResizeMode}
          // onLoadEvent={this.onLoadEvent}
        />
      );
    } else {
      let img = onPress ? this.props.source : this.state.source;
      if (typeof img === 'function') {
        img = img();
      }
      const ImageComponent = animate ? Animated.Image : Image;
      imageContent = (
        <ImageComponent
          {...rest}
          style={[style, animate ? { opacity: this.state.opacity } : null]}
          source={{ cache: 'force-cache', ...img }}
          resizeMode={this.state._resizeMode}
          onLoadEnd={this.onLoadEnd}
          blurRadius={blurRadius}
        />
      );
    }

    if (onPress) {
      return (
        <TouchableWithoutFeedback {...rest} onPress={onPress}>
          {accessibilityLabel ? <View>{imageContent}</View> : imageContent}
        </TouchableWithoutFeedback>
      );
    } else if (animate && this.state._useDuplo) {
      return (
        <Animated.View {...rest} style={[style, { opacity: this.state.opacity }]}>
          {imageContent}
        </Animated.View>
      );
    } else {
      return accessibilityLabel ? <View {...rest}>{imageContent}</View> : imageContent;
    }
  }
}

export default ImageHandler;
